import { Component, ChangeDetectionStrategy, Input, OnInit } from '@angular/core';
import { AppModule } from '../../../app-module';
import { User } from '../../class/user.class';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { AcuseDTO, TipoAcuseEnum } from '../../class/Acuse.class';

@Component({
    selector: 'oaj-acuse-itx',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'acuse.component.html',
    styleUrls: ['acuse.component.css'],
    imports: [AppModule],
})
export class AcuseComponent implements OnInit {
    title!: string;
    OrganoOrigen = "";
    OrganoDestino = "";
    Usuario: User = new User;
    @Input()
    acuse: AcuseDTO = new AcuseDTO;
    TipoAcuseEnum = TipoAcuseEnum;   

    ngOnInit(): void {
        this.OrganoOrigen = this.acuse.organoOrigen;
        this.OrganoDestino = this.acuse.organoDestino;
        switch (this.acuse.tipoAcuse) {
            case TipoAcuseEnum.Demanda:
                this.title = 'ACUSE DE ENVÍO DE DEMANDA VIA INTERCONEXIÓN';
                break;
            case TipoAcuseEnum.Promocion:
                this.title = 'ACUSE DE ENVÍO DE PROMOCIÓN VIA INTERCONEXIÓN';;
                break;
        }
    }

    /**
     * Imprime el acuse, se obtiene el elemento HTML que contiene el acuse, se calculan las dimensiones del contenido y del PDF, se convierte el contenido HTML a una imagen utilizando html2canvas, se crea un nuevo documento PDF utilizando jsPDF, se agrega la imagen al PDF y se guarda el archivo con un nombre basado en el tipo de acuse y el folio de recepción
     * @returns 
     */
    printAcuse() {
        const tabla = document.getElementById('areaPrint');

        if (!tabla) {
            console.error('Element with id "areaPrint" not found.');
            return;
        }

        const htmlWidth = tabla.offsetWidth;
        const htmlHeight = tabla.offsetHeight;

        const topLeftMargin = 50;

        const pdfWidth = htmlWidth + (topLeftMargin * 2); // Ancho del PDF
        const pdfHeight = (pdfWidth * 1.5) + (topLeftMargin * 2);

        const canvasImageWidth = htmlWidth;
        const canvasImageHeight = htmlHeight;

        const totalPDFPages = Math.ceil(htmlHeight / pdfHeight) - 1;

        const data = tabla;
        let NameFile = "Acuse.pdf";
        switch (this.acuse.tipoAcuse) {
            case TipoAcuseEnum.Demanda:
                NameFile = `Acuse-Demanda_${this.acuse.folioRecepcion}.pdf`;
                break;
            case TipoAcuseEnum.Promocion:
                NameFile = `Acuse-Promocion_${this.acuse.folioRecepcion}.pdf`;
                break;
        }
        const pdfPath = NameFile; // Nombre del archivo


        this.convertHtmlToPdf(data, pdfPath, pdfWidth, pdfHeight, topLeftMargin, canvasImageWidth, canvasImageHeight, totalPDFPages);
    }

    /**
     * Convierte el contenido HTML a un documento PDF, se utiliza html2canvas para renderizar el contenido HTML como un canvas, se obtiene la imagen del canvas y se crea un nuevo documento PDF utilizando jsPDF, se agrega la imagen al PDF y se guarda el archivo con el nombre especificado
     * @param htmlContent 
     * @param pdfPath 
     * @param pdfWidth 
     * @param pdfHeight 
     * @param topLeftMargin 
     * @param canvasImageWidth 
     * @param canvasImageHeight 
     * @param totalPDFPages 
     */
    convertHtmlToPdf(htmlContent: HTMLElement, pdfPath: string, pdfWidth: number, pdfHeight: number, topLeftMargin: number, canvasImageWidth: number, canvasImageHeight: number, totalPDFPages: number): void {
        html2canvas(htmlContent, { allowTaint: true }).then(canvas => {
            canvas.getContext('2d');
            const imgData = canvas.toDataURL("image/jpeg", 1.0);
            const pdf = new jspdf.jsPDF('p', 'pt', [pdfWidth, pdfHeight]);
            pdf.addImage(imgData, 'png', topLeftMargin, topLeftMargin, canvasImageWidth, canvasImageHeight);

            for (let i = 1; i <= totalPDFPages; i++) {
                pdf.addPage([pdfWidth, pdfHeight], 'p');
                pdf.addImage(imgData, 'png', topLeftMargin, - (pdfHeight * i) + (topLeftMargin * 4), canvasImageWidth, canvasImageHeight);
            }

            pdf.save(`${pdfPath}`);
        });
    }

}